import { Component, Input, OnInit } from '@angular/core';
import { FormWizardPageElement } from 'src/app/models/form-wizard-template.model';

@Component({
  selector: 'app-paragraph-element',
  templateUrl: './paragraph-element.component.html',
  styleUrls: ['./paragraph-element.component.scss']
})
export class ParagraphElementComponent implements OnInit {
  @Input() element: FormWizardPageElement | undefined;

  constructor() { }

  ngOnInit(): void {
  }

  public getText(): string {
    return this.element?.label ?? '';
  }
}
